import { Title } from '@zenterprise-inc/ui';

import { BusinessType } from '@/components/tax-refund/bank-account/contexts/bank-account-context';

export const TitleByPhoneNumber = ({
  bizName,
  businessType,
  hasBznavPhoneNumber
}: {
  bizName?: string;
  businessType: BusinessType;
  hasBznavPhoneNumber: boolean;
}) => {
  const displayName = (() => {
    if (!bizName)
      return (
        <>
          &apos;<span className={'break-all'}>고객</span>&apos;님의
        </>
      );
    if (businessType === 'corps')
      return (
        <>
          &apos;<span className={'break-all'}>{bizName}</span>&apos;의
        </>
      );
    return (
      <>
        <span className={'break-all'}>{bizName}</span>님의
      </>
    );
  })();

  const titleText = hasBznavPhoneNumber ? (
    <>
      마지막으로 {displayName}
      <br />
      환급받을 {businessType === 'corps' ? '법인 계좌를 입력해주세요' : '본인 계좌를 입력해주세요'}
    </>
  ) : (
    <>
      {displayName} 환급받을
      <br />
      {businessType === 'corps' ? '법인 계좌를 입력해주세요' : '본인 계좌를 입력해주세요'}
    </>
  );

  return <Title.Headline title={titleText} size="large" subText="잘못된 계좌번호나 타인 명의 계좌는 환급이 어려워요." />;
};
